export default __webpack_public_path__ + "static/media/head01_ko_pc.d2f9723a.png";